import { fontSize } from "./fontSize";

const baseTheme = {
  isMobile: "false",
  primary: "#0081C6",
  primaryDeep: "#1F6CA0",
  primaryLight: "#DCEAFF",
  red: "#c20114",
  redDeep: "#a50012",
  redBase: "#d43900",
  redLight: "#f5222d",
  blue: "#2b6ed2",
  lightBlue: "#508dde",
  bgLightBlue: "#ebf4fa",
  smaltBlue: "#537D98",
  white: "#ffffff",
  black: "#000",
  gray: "#d2d6da",
  lightGray: "#dce0e3",
  textColor: "#333f48",
  textGray: "#a5adb5",
  textLightGray: "#86909d",
  bgGray: "#e9ebed",
  progressBarGray: "#e6e6e6",
  errorRed: "#ff5961",
  errorBgRed: "#ffefef",
  textDeepGray: "#697684",
  qualityBlue: "#00beb3",
  bgDeepGray: "#f3f4f6",
  qualityDeepGray: "#b9c0c7",
  qualityLabel: "#a6adb5",
  imageBgColor: "#b7bdc4",
  premiumTier: "#FFB200",
  premiumPlusTier: "#FFB200",
  featureTier: "#A83399",
  standardTier: "#69B0E0",
  pageBgGray: "#f3f4f5",
  pageBg: "#f7f8f9",
  darkGreen: "#008744",
  greenBase: "#009e4f",
  lightGreen: "#00c694",
  lightGreenBg: "#e3f9f4",
  borderColor: "#c9c9c9",
  dateBorderColor: "#e5edf5",
  dateSelectionColor: "#b6c5db",
  bulkSelectBg: "#eef4fa",
  disabledColor: "#f5f5f5",
  requiredRed: "#e4002b",
  inputPlaceholderColor: "#697684",
  darkGoldenrod: "#ad7f16",
  creamBrulee: "#ffe099",
  lightBorderGray: "#e6e7e8",
  meadowGreen: "#149a7f",
  tangerineYellow: "#ed8b00",
  royalHeathPurple: "#93227e",
  deepMeadowGreen: "#007a5f",
  deepTangerineYellow: "#cd6b00",
  deepRoyalHeathPurple: "#73025e",
  iron: "#e6e7e8",
  Grenadier: "#d43900",
  pageBgWhite: "#fefefe",
  lightText: "#323f49",
  filterGrey: "#687685",
  filterItemHover: "#eff1f2",
  grannyApple: "#daf5ed",
  frenchLilac: "#f8e6f9",
  lighterGray: "#d9d9d9",
  linkWater: "#d2d5da",
  silverSand: "#b6b7b8",
  tangerine: "#ed8b00",
  premiumTierOpacity: "#ffb2001a",
  darkRed: "#b61f47",
  lightOrange: "#ff9a2a",
  defaultIconColor: "#333F48",
  pureGreen: "#00BEB3",
  menuActiveColor: "#0C59BC",
  menuHoverColor: "#0A4A9C",
  warning: "#FFB200",
};

// buttons
const buttonTheme = {
  buttonColor: baseTheme.blue,
  buttonBorder: baseTheme.blue,
  buttonBg: baseTheme.white,

  buttonHoverColor: baseTheme.textColor,
  buttonHoverBorder: baseTheme.textColor,
};

// Radio buttons
const radioButtonTheme = {
  radioButtonBorder: baseTheme.textDeepGray,
  radioButtonBg: baseTheme.white,
  radioButtonColor: baseTheme.textDeepGray,

  radioButtonCheckedBorder: baseTheme.blue,
  radioButtonCheckedBg: baseTheme.blue,
  radioButtonCheckedColor: baseTheme.white,

  radioButtonDisabledBg: baseTheme.disabledColor,
};

// Checkbox
const checkboxTheme = {
  checkboxCheckBg: baseTheme.blue,
  checkboxCheckBorder: baseTheme.blue,
};

// Input
const inputTheme = {
  inputBorder: baseTheme.gray,

  inputDisabledBg: `${baseTheme.bgGray} !important`,
  inputDisabledColor: `${baseTheme.textDeepGray} !important`,
  inputDisabledBorder: `${baseTheme.linkWater} !important`,
};

// tabs
const tabsTheme = {
  tabsNavColor: baseTheme.textDeepGray,
  tabsNavFontWeight: 500,
  tabsBarBorder: "#e8e8e8",
  tabsInkBarColor: baseTheme.blue,

  tabsNavActiveColor: baseTheme.blue,
  tabsNavActiveFontWeight: 500,
};

const stepsBarTheme = {
  stepBarDefaultBg: baseTheme.bgGray,
  stepBarActiveBg: "#2682c3",
  stepBarHoverBg: "#2682c3",
  stepBarTextColor: baseTheme.textColor,
  stepBarTextDisabledColor: baseTheme.textDeepGray,
};

const productTheme = {
  productStandardBg: "#f1f8fc",
  productFeatureBg: "#f5ebf4",
  productPremiumBg: "#fff5df",
};

const theme = {
  ...baseTheme,
  ...buttonTheme,
  ...radioButtonTheme,
  ...checkboxTheme,
  ...inputTheme,
  ...tabsTheme,
  ...stepsBarTheme,
  ...productTheme,
  fontSize,
};
type DefaultTheme = typeof theme;
export { theme, DefaultTheme };
